

export const styleWeb = {
    bannerh1: {
        color: '#fff',
        textTransform: 'none',
        fontSize: '22px',
        marginBottom: '3%'
    },

    backGroundVideo: {
        minWidth: '100%',
        minHeight: '100%',
        width: '100%',
        marginTop: '-40px'
    },

    /**
     * Container for the button on the hint box.
     */
    hintButtonContainer: {
        flexDirection: 'row',
        justifyContent: 'center'
    },
    headerliRight: { marginRight: '25px' },
    languageContainer: {
        marginRight: '25px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        border: 'none'
    },
    width100: { width: '100%' },
    width300: { width: '300px' },
    stickyPostion: {
        position: 'sticky'
    },
    cusrorPointer: { cursor: 'pointer' },
    widthandHeight: { width: '45px',
        height: '42px' },
    widthandHeightimg: { width: '45px',
        height: '42px',
        float: 'left' },

    h1w: {
        fontSize: '2.8em',
        lineHeight: 'normal'
    },
    disablePrejoinFooter: {
        textAlign: 'center',
        paddingTop: '5px'
    },
    marginLeft: {
        marginLeft: '17px'
    },
    footerColor2: {
        color: '#5E82B4'
    }

};
